import { styled } from "styled-components";

import { Website } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const FaviconImage = styled.img`
    width: 16px;
    height: 16px;
    border-radius: 2px;
`;

const FaviconContainer = styled(Flex)`
    width: 24px;
    height: 24px;
    border-radius: 6px;
    padding: 4px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

interface ICompetitorsFaviconIconProps {
    favicon?: string | null;
    domain?: string;
}

export const CompetitorsFaviconIcon = ({ favicon, domain }: ICompetitorsFaviconIconProps) => (
    <FaviconContainer>
        {favicon ? (
            <FaviconImage
                src={favicon}
                alt={`${domain} favicon`}
            />
        ) : (
            <Website
                size="xs"
                color={colorsPalettes.blue[400]}
            />
        )}
    </FaviconContainer>
);
